<template>
  <b-row>
    <b-col class="mt-2" v-for="(image, i) in images" sm="3" :key="i">
      <div class="image">
        <b-img class="img img-responsive full-width" :src="image" @click="index = i"></b-img>
      </div>
    </b-col>
    <vue-gallery-slideshow :images="images" :index="index" @close="index = null"></vue-gallery-slideshow>

    <b-col v-if="docs && docs.length <= 0">
      <p>ยังไม่มีรูป</p>
    </b-col>
  </b-row>
</template>

<script>
import HttpDoc from '../services/http/Doc'
import VueGallerySlideshow from 'vue-gallery-slideshow'

export default {
  name: 'DocList',
  components: {
    VueGallerySlideshow
  },
  props: ['docType', 'preventDelete', 'refId'],
  data () {
    return {
      mainProps: { class: 'w-50' },
      docs: [],
      index: null,
      images: []
    }
  },
  async mounted () {
    this.init()
    Window.Event.$on('reloadDoc-' + this.docType, this.init)
  },
  beforeDestroy () {
    Window.Event.$off('reloadDoc-' + this.docType)
  },
  methods: {
    async init () {
      var httpDoc = new HttpDoc(this.docType, this.refId)
      var docResponse = await httpDoc.getAllDoc()
      if (docResponse.code === 1) {
        this.docs = docResponse.data
        this.images = this.docs.map(x => 'data:image/jpeg;base64,' + x.imgBase64)
      } else if (docResponse.code === 12008) {

      } else {
        alert('โปรดติดต่อผู้ดูแลระบบ')
      }
    }
  }
}
</script>
